// src/components/Home/Home.jsx
import React from "react";
import Header from "./Header/header";
import Main from "./Main/main";
import Footer from "./Footer/footer";

function Home() {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default Home;
